
import apiRoute from "@/config/apiRoute";
import Request from "@/core/request";

import AppMain from "./components/AppMain";
import navbar from "./components/navbar/index.vue";
import PageFooter from "./components/footer/index.vue";

const page = {
    name: "AppLayout",
    components: {
        navbar,
        AppMain,
        PageFooter
    },
    data() {
        return {
            navData: {
                slogan: '',
                productNav: []
            }
        }
    },
    mixins: [],
    methods: {
        init() {
            const url = apiRoute.frontSetting;
            Request({
                url: url,
                method: "post",
            }).then((res) => {
                const { status, result} = res;
                if (status == 0) {
                    if (result) {
                      this.navData = result.navData
                    }
                }
            });
        }
    },
    created: function () {
        this.init();
    }
}
export default page


// WEBPACK FOOTER //
// ./src/layout/app/index.js